// src/subscreens/Home/HeroSection.js
import React from 'react';
import '../../../assets/css/home/HeroSection.css';

const HeroSection = ({ onExploreClick }) => {
  return (
    <section className="hs-hero-section">
      {/* Background Image Overlay */}
      <div className="hs-hero-image-background"></div>
      <div className="hs-hero-overlay"></div>
      
      {/* Floating Particles Animation */}
      <div className="hs-floating-particles">
        <div className="hs-particle hs-particle-1"></div>
        <div className="hs-particle hs-particle-2"></div>
        <div className="hs-particle hs-particle-3"></div>
        <div className="hs-particle hs-particle-4"></div>
        <div className="hs-particle hs-particle-5"></div>
        <div className="hs-particle hs-particle-6"></div>
      </div>

      <div className="container">
        <div className="row align-items-center min-vh-100">
          <div className="col-lg-8 mx-auto text-center">
            <h1 className="hs-hero-title mb-4">
              CircleHub – Learn Better, Together
            </h1>
            <p className="hs-hero-subtitle mb-5">
              Transform your study sessions with AI-powered tools, collaborative spaces, and smart tracking to achieve academic excellence together.
            </p>
            <div className="hs-hero-buttons">
              <button className="btn btn-primary btn-lg me-3 mb-3">
                Get Started
              </button>
              <button 
                className="btn btn-outline-light btn-lg mb-3"
                onClick={onExploreClick}
              >
                Explore Features
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;